import { classes } from 'html-classes';
import { ReactNode, RefObject } from 'react';
import Skeleton from 'react-loading-skeleton';

import { SkeletonSize } from './interfaces';
import styles from './MobileHeaderCard.module.scss';

export const OrderCardSkeleton = ({
  showContent,
  showArrowSection,
  arrowContent,
  skeletonSize,
}: {
  showContent?: boolean;
  showArrowSection?: boolean;
  arrowContent?: ReactNode;
  skeletonSize: RefObject<SkeletonSize>;
}) => (
  <>
    <div className={styles.iconWr}>
      <Skeleton
        className={styles.iconSkeleton}
        containerClassName={styles.skeleton}
      />
    </div>
    {showContent && (
      <div className={classes([styles.content, styles.loading])}>
        <Skeleton
          className={styles.timeSekeleton}
          containerClassName={styles.skeleton}
          width={skeletonSize.current?.caption}
        />
        <Skeleton
          className={styles.statusSkeleton}
          containerClassName={styles.skeleton}
          width={skeletonSize.current?.title}
        />
      </div>
    )}
    {showArrowSection && arrowContent}
  </>
);
